import { DatePicker } from '@pankod/refine-antd';
import dayjs from 'dayjs';
import React from 'react';
import './custom-date-picker.css';

interface CustomDatePickerProps {
  className?: string;
  value: [Date, Date];
  style?: React.CSSProperties;
  onChange: (values: any, formatString: [string, string]) => void;
  format?: string;
  customDisabledDate?: (date: dayjs.Dayjs) => boolean;
}

export const CustomDatePicker: React.FC<CustomDatePickerProps> = (props) => {
  const { RangePicker } = DatePicker;
  const defaultDisabledDate = (date: dayjs.Dayjs) => date > dayjs();

  return (
    <RangePicker
      className={props.className}
      style={props.style}
      value={[dayjs(props.value[0]), dayjs(props.value[1])]}
      onChange={props.onChange}
      format={props.format || 'DD-MM-YYYY'}
      disabledDate={props.customDisabledDate || defaultDisabledDate}
      getPopupContainer={() => document.body}
      dropdownClassName="custom-date-range-dropdown"
      ranges={{
        'This Week': [dayjs().startOf('week'), dayjs().endOf('week')],
        'Last Month': [
          dayjs().startOf('month').subtract(1, 'month'),
          dayjs().endOf('month').subtract(1, 'month'),
        ],
        'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
        'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
        'All Time': [dayjs('1970-01-01'), dayjs()],
      }}
    />
  );
};
